import { Flex, Stack } from '@chakra-ui/react';
import Button, { ButtonVariants } from '@components/interactive/Button';
import { useRouter } from 'next/router';
import Container from './Container';

const Birthday = ({ goNext }) => {
  const router = useRouter();

  const onClick = (gender: string) => goNext({ gender });

  return (
    <Container header="What's your gender?">
      <Stack w="100%" alignItems="center" pt={4} gap={4} spacing={0}>
        <Flex gap={4} w="100%" py={4}>
          <Button flex={1} onClick={() => onClick('female')}>
            Female
          </Button>
          <Button flex={1} onClick={() => onClick('male')}>
            Male
          </Button>
        </Flex>
        <Button type="button" onClick={router.back} variant={ButtonVariants.tertiary} w="100%">
          Back
        </Button>
      </Stack>
    </Container>
  );
};

export default Birthday;
